export default __webpack_public_path__ + "static/media/2007.5755ba51.jpg";